/** @format */

import { useTranslation } from "react-i18next";
import { ReactComponent as CheckCircle } from "bootstrap-icons/icons/check-circle-fill.svg";
import { ReactComponent as Circle } from "bootstrap-icons/icons/circle.svg";
import { ResourceReference } from "../../../../types";
import { QueryProps } from "../../resourceIndexUI/ResourcesIndexUI";
import { filterResources } from "../utils";

export type Status = "live" | "draft";

const StatusFilter: React.FC<{
  isLoading: boolean;
  query: QueryProps;
  refs: ResourceReference[];
  handleQueryItemClick: (
    thisValue: string,
    thisQueryType: keyof QueryProps,
  ) => void;
}> = ({ isLoading, query, refs, handleQueryItemClick }) => {
  const { t: _ } = useTranslation();

  const liveRefsCount = filterResources(refs, "status", query).filter(
    (ref) => ref.Status === "live",
  ).length;
  const draftRefsCount = filterResources(refs, "status", query).filter(
    (ref) => ref.Status === "draft",
  ).length;

  return (
    <div className="card shadow mb-3" key="tags-filter">
      <div className="card-body">
        <h5>{_("Status")}</h5>

        {isLoading ? (
          ["live", "draft"].map((i) => (
            <button
              key={i}
              className={`w-100 btn btn-light text-start py-0 mb-2`}
              data-testid={"loading-" + i}
            >
              <Circle />
              &emsp;<span className="placeholder col-4"></span>
              <span className="float-end placeholder col-1"></span>
            </button>
          ))
        ) : (
          <>
            <button
              onClick={() => {
                handleQueryItemClick("live", "status");
              }}
              className={`w-100 btn btn-light text-start py-0 mb-2`}
              data-testid="live"
            >
              {query.status === "live" ? (
                <CheckCircle data-testid="live-checked" />
              ) : (
                <Circle data-testid="live-blank" />
              )}
              &emsp; {_("live")}
              <span className="float-end text-muted" data-testid="live-count">
                {liveRefsCount}
              </span>
            </button>
            <button
              onClick={() => {
                handleQueryItemClick("draft", "status");
              }}
              className={`w-100 btn btn-light text-start py-0 mb-2`}
              data-testid="draft"
            >
              {query.status === "draft" ? (
                <CheckCircle data-testid="draft-checked" />
              ) : (
                <Circle data-testid="draft-blank" />
              )}
              &emsp; {_("draft")}
              <span className="float-end text-muted" data-testid="draft-count">
                {draftRefsCount}
              </span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default StatusFilter;
